import { Box, Button } from '@zillow/constellation-10';
import { IconFilterOutline } from '@zillow/constellation-icons';

export default function FiltersSelectorSkeleton(): JSX.Element {
  return (
    <Button
      emphasis="outlined"
      icon={<IconFilterOutline />}
      iconPosition="start"
      size="md"
      tone="brand"
      css={{ width: 'max-content' }}
    >
      <Box css={{ xxlDown: { display: 'none' } }}>Filters</Box>
    </Button>
  );
}
